import axios from 'axios';
import useCurrentUser from '../hooks/useCurrentUser';
import { API_HOST } from '../constants/constants';
export const getPatientData = async (page, rowsPerPage, order, orderBy, searchTerm, viewing, list) => {
  let apiURL = `${API_HOST}/admin/patient_data?page=${page}&per_page=${rowsPerPage}&order=${order}&orderBy=${orderBy}`;
  if (searchTerm) {
    apiURL += `&q=${encodeURIComponent(searchTerm)}`;
  }
  if (viewing) {
    apiURL += `&viewing=${viewing}`;
  }
  if (list) {
    apiURL += `&list=${list}`;
  }
  const { token, userID } = useCurrentUser();
  try {
    const { data } = await axios.get(apiURL, {
      headers: {
        Authorization: 'Bearer ' + token,
        'x-dqpn-user-id': userID,
      },
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};
